// `rounded` usa Material Symbols Rounded (default: Outlined, el de toda la app) y `filled` la
// variante rellena (eje FILL, que index.html carga sólo para Rounded). Los dos apagados = lo de siempre.
export default function Icon({ name, size = 24, className = "", style = {}, rounded = false, filled = false }) {
  return (
    <span
      className={`${rounded ? "material-symbols-rounded" : "material-symbols-outlined"} ${className}`}
      style={{ fontSize: size, lineHeight: 1, userSelect: "none", ...(filled && { fontVariationSettings: "'FILL' 1" }), ...style }}
    >
      {name}
    </span>
  );
}
